import { useGetLimitationsQuery } from "@/shared/services";
import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";

export const AiImageLimitations = () => {
  const { data: aiLimits, isLoading } = useGetLimitationsQuery("image");
  if (isLoading) return null;
  return (
    <div
      className={cn(
        "tw-invisible tw-absolute tw-bottom-[18px] tw-right-6 tw-flex tw-items-center tw-justify-end tw-text-[10px] tw-font-semibold tw-text-blue-500 tw-opacity-0 tw-transition-all",
        aiLimits && "tw-visible tw-opacity-100",
      )}
    >
      <Icon icon="ri-copper-coin-fill" className="tw-mr-1 tw-text-[#FFB82E]" />
      <>
        {aiLimits?.limit && aiLimits?.limit > 999 ? (
          "Unlimited tokens"
        ) : (
          <>
            {Math.max(0, (aiLimits?.limit ?? 0) - (aiLimits?.current ?? 0))}/
            {aiLimits?.limit ?? 0} TOKENS LEFT
          </>
        )}
      </>
    </div>
  );
};
